module.exports = __webpack_public_path__ + "media/images/web/landings/footer-c0c1956bae42f1260e89bc99026ab501.jpg";